import { render } from "./AdministratorOneCourseContent.vue?vue&type=template&id=f69517fa&scoped=true"
import script from "./AdministratorOneCourseContent.vue?vue&type=script&lang=js"
export * from "./AdministratorOneCourseContent.vue?vue&type=script&lang=js"

import "./AdministratorOneCourseContent.vue?vue&type=style&index=0&id=f69517fa&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f69517fa"]])

export default __exports__